import { Navigate } from 'react-location'
import { useAuth } from '../containers/AuthContainer'

interface Props {
  render: () => JSX.Element | null
  defaultPath?: string
}

function PublicRouteRPC(props: Props): JSX.Element | null {
  const { defaultPath = '/', render } = props
  const { isAuthenticated } = useAuth()
  if (isAuthenticated()) return <Navigate to={defaultPath} />

  return render()
}

export default PublicRouteRPC
